import {createAction} from 'redux-act'

export const setTradeModalVisible = createAction('SET_TRADE_MODAL_VISIBLE')
export const setTradeForm = createAction('SET_TRADE_FORM')
export const closeTradeForm = createAction('CLOSE_TRADE_FORM')

export const setNotificationIds = createAction('SET_NOTIFICATIONS_IDS')



